import { Component, Inject, OnDestroy, PLATFORM_ID } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { RouterModule } from '@angular/router';
import { assets } from '../../core/constants/assets.const';
import { TranslateModule } from '@ngx-translate/core';
import { HeaderComponent } from '../../shared/components/header/header.component';
import { FooterComponent } from '../../shared/components/footer/footer.component';
import { AuthService } from '../../services/auth.service';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { User } from '../../models/auth.model';
import { environment } from '../../../environments/environment';
import { SpinnerService } from '../../services/spinner.service';

@Component({
  selector: 'xplora-website-main',
  standalone: true,
  imports: [
    MatIconModule,
    MatMenuModule,
    CommonModule,
    RouterModule,
    TranslateModule,
    HeaderComponent,
    FooterComponent
  ],
  templateUrl: './main.component.html',
  styleUrl: './main.component.scss'
})
export class MainComponent implements OnDestroy {
  private subscriptionSubject$!: Subscription;
  protected assetsConst = assets;
  private destroy: Subject<boolean> = new Subject<boolean>();
  public sidenavWidth = 200;
  constructor(
    public _authService: AuthService,
    private spinnerService: SpinnerService,
    @Inject(PLATFORM_ID) private platformId: object
  ) {
    this.subscriptionSubject$ = this._authService.profileDetails
      .pipe(takeUntil(this.destroy))
      .subscribe({
        next: (res: User | null) => {
          if (res && res !== null) {
            if (!this._authService.profileDetails.value) {
              this._authService.profileDetails.next(res);
            }
          } else {
            if (isPlatformBrowser(this.platformId)) {
              if (localStorage.getItem(`${environment.storageKey}`)) {
                this.fetchUserProfile();
              }
            }
          }
        }
      });
  }

  fetchUserProfile(): void {
    this._authService
      .getProfile()
      .pipe(takeUntil(this.destroy))
      .subscribe({
        next: (res: User) => {
          this._authService.profileDetails.next(res);
        },
        error: () => {
        }
      });
  }

  toggleSidenav(): void {
    this._authService.toggleSidebarView();
  }

  ngOnDestroy(): void {
    this.destroy.complete();
    this.destroy.unsubscribe();
  }
}
